<template>
  <div class="spa-review-score-selector">
    <div
      v-if="label"
      class="spa-review-score-selector__label"
    >
      {{ label }}
    </div>
    <div class="spa-review-score-selector__input">
      <a
        v-for="(leafType, i) in scoreLeafTypeList"
        :key="i"
        class="spa-review-score-selector__input__btn"
        @click="selectValue(i + 1)"
      >
        <ScoreLeafIcon
          :size="21"
          class="spa-review-score-selector__input__icon"
          :type="leafType"
        />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import ScoreLeafIcon from '../../shared/icons/ScoreLeaf.icon.vue'

export default defineNuxtComponent({
  components: {
    ScoreLeafIcon,
  },
  props: {
    label: { type: String, default: () => '' },
    modelValue: { type: Number, required: true },
  },
  setup(props, {emit}) {
    const scoreLeafTypeList = computed(() => {
      const iconTypes: string[] = []

      let score = props.modelValue

      for (let i = 1; i <= 5; i++) {
        if (score >= 1) {
          iconTypes.push('full')
          score--
        } else if (score > 0) {
          iconTypes.push('half')
          score = 0
        } else {
          iconTypes.push('empty')
        }
      }

      return iconTypes
    })

    function selectValue(value: number) {
      emit('update:modelValue', value)
    }

    return {
      scoreLeafTypeList,
      selectValue,
    }
  }
})
</script>

<style lang="scss" scoped>
.spa-review-score-selector {
  @apply flex;
  @apply flex-row;
  @apply justify-between items-center;

  &__label {
    @apply text-gray-500;
    @apply font-semibold;
  }
  &__input {
    @apply flex;
    @apply flex-row;

    &__btn {
      cursor: pointer;
    }

    &__icon {
      @apply mx-1 py-1;
    }
  }
}
</style>
